// src/Components/Doctors.js
import React from 'react';
import './MeetDoctors.css';
import drParacha from "./assets/dr-Paracha.jpg";
import usermale from "./assets/user-male.webp";
import userfemale from "./assets/user-female.png";

const MeetDoctors = () => {
    return (
        <div className="doctors-page">
            {/* Hero Section */}
            <section className="page-hero-banner">
                <div className="container">
                    <h1>Our Team of Professionals</h1>
                    <p>Expert Care, Compassionate Touch</p>
                </div>
            </section>

            {/* Lead Doctor Section */}
            <section className="lead-doctor section-padding">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 mb-4 mb-lg-0">
                            <div className="doctor-profile-img">
                                <img src={drParacha} alt="Dr. Atif Paracha - Privacy Protected Profile" className="img-fluid rounded" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <h2 className="section-title">Dr. Atif Paracha</h2>
                            <p className="lead">Master Trainer of Cortico Basal Implantology | President of I.A.C.I – Pakistan</p>
                            <p><strong>Privacy Commitment:</strong> Dr. Atif Paracha and Paracha Dental Surgery are committed to protecting your online privacy. Our website operates with zero data collection, no tracking cookies, and complete GDPR/CCPA compliance. You can browse our doctor's credentials and expertise anonymously without any personal information being stored.</p>
                            <p>At Paracha Dental Surgery, we value your trust both in our clinical care and your digital privacy. This website uses no analytics scripts, no third-party trackers, and collects no personal data. Your browsing activity remains completely anonymous and protected.</p>
                            <hr />
                            <div className="credentials">
                                <h5>Credentials & Expertise:</h5>
                                <ul>
                                    <li>B.D.S, R.D.S – Certified and licensed dental surgeon.</li>
                                    <li>C.Orth (USA) – Specialized training in orthodontics from the USA.</li>
                                    <li>C.Implant (USA) – Advanced implantology certification from the USA.</li>
                                    <li>American National Board Certified – Globally recognized qualifications.</li>
                                    <li>Basal Implant Specialist – Accredited by the International Academy of Cortical Implantology.</li>
                                </ul>
                                <small className="privacy-note" style={{ display: 'block', marginTop: '15px', fontSize: '12px', color: '#9A36C5' }}>
                                    🔒 All credential information is provided for transparency — no personal data collected during your visit.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Department Managers Section - Privacy Compliant */}
            <section className="department-managers section-padding bg-light">
                <div className="container">
                    <h2 className="section-title text-center mb-5">Department Managers</h2>
                    <p className="text-center mb-4" style={{ maxWidth: '600px', margin: '0 auto 2rem auto', fontSize: '13px', color: '#666' }}>
                        🛡️ Browse our team profiles with complete privacy — no tracking, no data collection, 100% anonymous browsing.
                    </p>
                    <div className="row">
                        <div className="col-md-6 col-6 mb-4">
                            <div className="doctor-card text-center">
                                <img src={usermale} alt="Dr. Atif Paracha - Privacy Protected" className="img-fluid rounded-circle mb-3" />
                                <h5>Dr. Atif Paracha</h5>
                                <p>Senior Dentist</p>
                                <small style={{ fontSize: '10px', color: '#9A36C5' }}>🔒 Profile viewed privately</small>
                            </div>
                        </div>
                        <div className="col-md-6 col-6 mb-4">
                            <div className="doctor-card text-center">
                                <img src={userfemale} alt="Dr. Maliha Atif - Privacy Protected" className="img-fluid rounded-circle mb-3" />
                                <h5>Dr. Maliha Atif</h5>
                                <p>Senior Dentist</p>
                                <small style={{ fontSize: '10px', color: '#9A36C5' }}>🔒 Profile viewed privately</small>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-3">
                        <small style={{ fontSize: '11px', color: '#888' }}>
                            ✅ GDPR Compliant | ✅ CCPA Compliant | ✅ Zero Tracking | ✅ Cookie-Free
                        </small>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MeetDoctors;